import { makeRequest } from './data_utils';

const saveLogItem = (payload) => {
    const body = {
      userId: payload.userId,
      action: payload.action,
      type: payload.type,
      value: payload.value
    };
    return makeRequest(`log/`, 'POST', body);
};

export const dataLog = {
    saveLogItem
};
